import type { ReactNode, FC } from 'react';
import { useRef } from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import ScrollableContent from '@wix/da-ds/pkg/ScrollableContent';
import { FolderListMobile } from '../../../stash/FolderList';

import s from './FoldersTab.scss';

interface Props {
  /** an optional rendered component that precedes all the items in the folders list */
  elementBeforeList?: ReactNode;
}

const FoldersTab: FC<Props> = ({ elementBeforeList }) => {
  const scrollableRef = useRef<HTMLElement | null>(null);

  return (
    <ScrollableContent
      wrapperClassName={s['content-wrapper']}
      innerRef={el => (scrollableRef.current = el)}
    >
      {elementBeforeList}
      <BiLoggerContextProvider value={{ sectionname: 'subfolders' }}>
        <div className={s['list-wrapper']}>
          <FolderListMobile withCreateButton withFolderActions />
        </div>
      </BiLoggerContextProvider>
    </ScrollableContent>
  );
};
FoldersTab.displayName = 'FoldersTab';

export default FoldersTab;
